export const globalStore = {
  state: {
    currentLevel: 1,
    globalLoading: true,
    isMobile: false,
    breakpointMobile: 1024,
    breakpoints: {
      xs: 576,
      sm: 768,
      md: 1024,
      lg: 1280
    },
    mediaQueries: {
      min: {
        xs: window.matchMedia('(min-width: 576px)'),
        sm: window.matchMedia('(min-width: 768px)'),
        md: window.matchMedia('(min-width: 1024px)'),
        lg: window.matchMedia('(min-width: 1280px)')
      },
      max: {
        xs: window.matchMedia('(max-width: 576px)'),
        sm: window.matchMedia('(max-width: 768px)'),
        md: window.matchMedia('(max-width: 1024px)'),
        lg: window.matchMedia('(max-width: 1280px)')
      }
    },
    browser: null,
    userGroupId: '62',
    exclTaxGroups: [2571, 2548, 8442, 10769, 16758, 21832, 22404, 22466, 22832, 36964, 37277, 44676, 45573, 46015],
    modalOpen: false,
    modalItem: {},
    IE: /MSIE|Trident/.test(window.navigator.userAgent),
    countLoading: 0,
    adminMode: false,
    adminData: {},
    delTimeSettings: {},
    level1Tags: [],
    postcatrdExcludedGroups: [],
    externalCardExcludedGroups: [],
    pricesExtraChars: {
      default: 0,
      default_net: 0
    },
    pricesPostcard: {
      default: 0,
      default_net: 0
    },
    externalCard: {
      default: 0,
      default_net: 0
    },
    pricesLogoProduct: {
      default: 0,
      default_net: 0
    },
    pricesSinglePackageProduct: {
      default: 0,
      default_net: 0
    },
    pricesSchuberProduct: {
      default: 0,
      default_net: 0
    },
    pricesOwnMotiveProduct: {
      default: 0,
      default_net: 0
    },
    // Implementierung unvollständig - soll nach und nach hart gecodete Preise ablösen
    pricesShipping: {
      bulkDe: 1.9
    },
    freeBulkShippingDe: 100,
    redirectCon: false,
    // Composer (new configurator)
    orderQtySize: {},
    composerModules: {},
    composerEnvironment: '',
    lvl1Loaded: false,
    lvl3Loaded: false,
    msgSettings: {},
    holidays: { 2022: { 10: { 31: true, '03': true }, 11: { 16: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '04': { 15: true, 18: true }, '05': { 26: true, '01': true }, '06': { '06': true } }, 2023: { 10: { 31: true, '03': true }, 11: { 22: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '04': { 10: true, '07': true }, '05': { 18: true, 29: true, '01': true } }, 2024: { 10: { 31: true, '03': true }, 11: { 20: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '03': { 29: true }, '04': { '01': true }, '05': { 20: true, '01': true, '09': true } }, 2025: { 10: { 31: true, '03': true }, 11: { 19: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '04': { 18: true, 21: true }, '05': { 29: true, '01': true }, '06': { '09': true } }, 2026: { 10: { 31: true, '03': true }, 11: { 18: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '04': { '03': true, '06': true }, '05': { 14: true, 25: true, '01': true } }, 2027: { 10: { 31: true, '03': true }, 11: { 17: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '03': { 26: true, 29: true }, '05': { 17: true, '01': true, '06': true } }, 2028: { 10: { 31: true, '03': true }, 11: { 22: true }, 12: { 25: true, 26: true }, '01': { '01': true }, '04': { 14: true, 17: true }, '05': { 25: true, '01': true }, '06': { '05': true } } },
    arag: {
      active: false,
      data: {}
    },
    faq: {},
    faqLoaded: false,
    noticeBanner: {},
    postcardMessageTemplates: []
  },
  getters: {
    getFaq: state => {
      return state.faq;
    },
    isFaqLoaded: state => {
      return state.faqLoaded;
    },
    getArag: state => {
      return state.arag;
    },
    getMsgSettings: state => {
      return state.msgSettings;
    },
    getPostcardExcludedGroups: state => {
      return state.postcatrdExcludedGroups;
    },
    getExternalCardExcludedGroups: state => {
      return state.externalCardExcludedGroups;
    },
    getLvl1Loaded: state => {
      return state.lvl1Loaded;
    },
    getLvl3Loaded: state => {
      return state.lvl3Loaded;
    },
    getComposerModules: state => {
      return state.composerModules;
    },
    getComposerEnvironment: state => {
      return state.composerEnvironment;
    },
    getCurrentLevel: state => {
      return state.currentLevel;
    },
    getGlobalLoading: state => {
      return state.globalLoading;
    },
    isMobile: state => {
      return state.isMobile;
    },
    getBrowser: state => {
      return state.browser;
    },
    getBreakpointMobile: state => {
      return state.breakpointMobile;
    },
    getMediaQueries: state => {
      return state.mediaQueries;
    },
    getUserGroupId: state => {
      return state.userGroupId;
    },
    getExclTaxGroups: state => {
      return state.exclTaxGroups;
    },
    getModalOpen: state => {
      return state.modalOpen;
    },
    getModalItem: state => {
      return state.modalItem;
    },
    isB2b: state => {
      // return state.exclTaxGroups.includes(parseInt(state.userGroupId));
      return true;
    },
    groupAbb: state => {
      // return state.exclTaxGroups.includes(parseInt(state.userGroupId)) ? 'b2b' : 'b2c';
      return 'b2b';
    },
    isIE: state => {
      return state.IE;
    },
    getCountLoading: state => {
      return state.countLoading;
    },
    isAdminMode: state => {
      return state.adminMode;
    },
    getAdminData: state => {
      return state.adminData;
    },
    getPricesExtraChars: state => {
      return state.pricesExtraChars;
    },
    getPricesPostcard: state => {
      return state.pricesPostcard;
    },
    getPriceExternalCard: state => {
      return state.externalCard;
    },
    getPricesLogoProduct: state => {
      return state.pricesLogoProduct;
    },
    getPricesSchuberProduct: state => {
      return state.pricesSchuberProduct;
    },
    getPricesOwnMotiveProduct: state => {
      return state.pricesOwnMotiveProduct;
    },
    getPricesShipping: state => {
      return state.pricesShipping;
    },
    getPricesSinglePackageProduct: state => {
      return state.pricesSinglePackageProduct;
    },
    getHolidays: state => {
      return state.holidays;
    },
    getRedirectCon: state => {
      return state.redirectCon;
    },
    getNoticeBanner: state => {
      return state.noticeBanner;
    },
    getFreeBulkShippingDe: state => {
      return state.freeBulkShippingDe;
    },
    // Composer (new configurator)
    getOrderQtySize: state => {
      return state.orderQtySize;
    },

    getPostcardMessageTemplates: state => {
      return state.postcardMessageTemplates;
    },
    getDelTimeSettings: state => {
      return state.delTimeSettings;
    },
    getLevel1Tags: state => {
      return state.level1Tags;
    }
  },
  mutations: {
    setArag(globalState, value) {
      globalState.arag = value;
    },
    setMsgSettings(globalState, value) {
      globalState.msgSettings = value;
    },
    setPostCardExcludedGroups(globalState, value) {
      globalState.postcatrdExcludedGroups = value;
    },
    setExternalCardExcludedGroups(globalState, value) {
      globalState.externalCardExcludedGroups = value;
    },
    setLvl1Loaded(globalState, value) {
      globalState.lvl1Loaded = value;
    },
    setLvl3Loaded(globalState, value) {
      globalState.lvl3Loaded = value;
    },
    setComposerModules(globalState, value) {
      globalState.composerModules = value;
    },
    setComposerEnvironment(globalState, value) {
      globalState.composerEnvironment = value;
    },
    setBrowser(globalState, value) {
      globalState.browser = value;
    },
    setCurrentLevel(globalState, level) {
      globalState.currentLevel = level;
    },
    setIsMobile(globalState, isMobile) {
      globalState.isMobile = isMobile;
    },
    setGlobalLoading(globalState, loading) {
      globalState.globalLoading = loading;
    },
    setUserGroupId(globalState, id) {
      globalState.userGroupId = id;
    },
    setModalOpen(globalState, open) {
      globalState.modalOpen = open;
    },
    setModalItem(globalState, item) {
      globalState.modalItem = item;
    },
    incrementCountLoading(globalState) {
      globalState.countLoading += 1;
    },
    decrementCountLoading(globalState) {
      globalState.countLoading -= 1;
    },
    setAdminMode(globalState, mode) {
      globalState.adminMode = mode;
    },
    setAdminData(globalState, data) {
      globalState.adminData = data;
    },
    setPricesExtraChars(globalState, prices) {
      if (prices === null) {
        globalState.pricesExtraChars = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.pricesExtraChars = prices;
      }
    },
    setPricesPostcard(globalState, prices) {
      if (prices === null) {
        globalState.pricesPostcard = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.pricesPostcard = prices;
      }
    },
    setPriceExternalCard(globalState, prices) {
      if (prices === null) {
        globalState.externalCard = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.externalCard = prices;
      }
    },
    setPricesLogoProduct(globalState, prices) {
      if (prices === null) {
        globalState.pricesLogoProduct = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.pricesLogoProduct = prices;
      }
    },
    setPricesSchuberProduct(globalState, prices) {
      if (prices === null) {
        globalState.pricesSchuberProduct = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.pricesSchuberProduct = prices;
      }
    },
    setPricesOwnMotiveProduct(globalState, prices) {
      if (prices === null) {
        globalState.pricesOwnMotiveProduct = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.pricesOwnMotiveProduct = prices;
      }
    },
    setPricesSinglePackageProduct(globalState, prices) {
      if (prices === null) {
        globalState.pricesSinglePackageProduct = {
          default: 0,
          default_net: 0
        };
      } else {
        globalState.pricesSinglePackageProduct = prices;
      }
    },
    setRedirectCon(globalState, value) {
      globalState.redirectCon = value;
    },
    setOrderQtySize(globalState, sizes) {
      globalState.orderQtySize = sizes;
    },
    setFaq(globalState, faq) {
      globalState.faq = faq;
      globalState.faqLoaded = true;
    },
    setNoticeBanner(globalState, noticeBanner) {
      globalState.noticeBanner = noticeBanner;
    },
    setPostcardMessageTemplates(globalState, postcardMessageTemplates) {
      globalState.postcardMessageTemplates = postcardMessageTemplates;
    },
    setDelTimeSettings(globalState, delTimeSettings) {
      globalState.delTimeSettings = delTimeSettings;
    },
    setLevel1Tags(globalState, level1Tags) {
      globalState.level1Tags = level1Tags;
    },
    setShipping(globalState, shippingSettings) {
      globalState.freeBulkShippingDe = shippingSettings.bulk_free_de;
      globalState.pricesShipping.bulkDe = shippingSettings.price_bulk_de;
    }
  }
};
